var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-country-interstitial-copy.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryCodeInterstitial")),"countryCodeContent");
frame.set("countryInterstitialKeys", t_1, true);
if(frame.topLevel) {
context.setVariable("countryInterstitialKeys", t_1);
}
if(frame.topLevel) {
context.addExport("countryInterstitialKeys", t_1);
}
output += "<div class=\"c-interstitial__copy o-row o-column o-extra-small--12 ";
if(!runtime.contextOrFrameLookup(context, frame, "isModal")) {
output += " o-large--7 ";
;
}
output += "\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <h2 class=\"c-interstitial__title\">\n            ";
output += runtime.suppressValue((lineno = 7, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryInterstitialKeys")),"welcomeText")])), env.opts.autoescape);
output += "\n        </h2>\n\n    </div>\n\n    ";
output += "\n\n    <div class=\"o-column o-extra-small--12 o-medium--12\">\n\n        <p class=\"c-interstitial__p\">\n            ";
output += runtime.suppressValue((lineno = 23, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "countryInterstitialKeys")),"shippingPriceOfferText")])), env.opts.autoescape);
output += "\n        </p>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-country-interstitial-copy.j2"] , dependencies)